import moment from 'moment';
import * as Sentry from '@sentry/react';

const getAppVersion = () => process.env.REACT_APP_VERSION || 'dev';
const getBuildTime = () => process.env.REACT_APP_BUILD_TIME || '';

const getToken = () => sessionStorage.getItem('SISGASREC.ACCESS_TOKEN');

const removeTokens = () => {
  sessionStorage.removeItem('SISGASREC.ACCESS_TOKEN');
  localStorage.removeItem('SISGASREC.REFRESH_TOKEN');
  try {
    Sentry.setUser(null);
  } catch (e) {
    /* best-effort */
  }
};

const removeTypeUser = () => {
  sessionStorage.removeItem('SISGASREC.TYPE_USER');
};

function useQuery(useLocation) {
  return new URLSearchParams(useLocation().search);
}

const formatNumber = value => {
  if (value || value === 0) {
    const numberString = value.toString().replace('.', ',');

    const decimal = numberString.split(',');
    const formattedValue = `${decimal[0].split(/(?=(?:...)*$)/).join('.')}${
      decimal?.[1] ? `,${decimal[1]}` : ''
    }`;

    return formattedValue;
  }
  return 0;
};

const formatPieChart = value => {
  if (value?.data?.length) {
    const data = value?.data?.slice()

    const formatData = data?.reduce((acc, item) => {
      acc.push({ name: item["name"], value: Number(item["total"]) })
      return acc
    }, [])

    return formatData
  }
  return null;
};

const checkDate = e => {
  const today = moment();
  return (
    moment(e, 'DD/MM/YYYY').isValid() &&
    !moment(e, 'DD/MM/YYYY').isAfter(today, 'DD/MM/YYYY')
  );
};

const handleText = (text, limit) => {
  if (text) {
    if (text?.length > limit) {
      const newText = text?.slice(0, limit);
      return `${newText?.charAt(0).toUpperCase() + newText?.slice(1)}...`;
    }
    return text?.charAt(0).toUpperCase() + text?.slice(1);
  }
  return null;
};

const replaceNumber = search => {
  if (!search) {
    return null;
  }
  const newSearch = search.replace('.', '');
  return Number(newSearch.replace(',', '.'));
};

const normalizeDecimal = value => {
  if (value === undefined || value === null || value === '') {
    return value;
  }

  if (typeof value === 'number') {
    return value;
  }

  const stringValue = String(value).trim();

  if (!stringValue || !stringValue.includes(',')) {
    return stringValue;
  }

  return stringValue.replace(/\./g, '').replace(',', '.');
};

const replaceDate = ({ search, searchFormat, bdFormat }) => {
  if (!search) {
    return null;
  }
  if (moment(search, searchFormat).isValid()) {
    return moment(search, searchFormat).format(bdFormat);
  }
  return search;
};

const replaceStatus = ({ search, options }) => {
  if (!search) {
    return null;
  }
  if (options[search.toLowerCase()]) {
    return options[search.toLowerCase()];
  }
  return null;
};

export {
  getToken,
  getAppVersion,
  getBuildTime,
  removeTokens,
  removeTypeUser,
  useQuery,
  formatPieChart,
  formatNumber,
  checkDate,
  handleText,
  replaceNumber,
  normalizeDecimal,
  replaceDate,
  replaceStatus,
};
